import {
    IState, itemSelector,
    listSelector,
    parameterisedItemSelector
} from "../query-facade";
import { BaseObject } from "../../../core/business-objects/base-object/base-object.model";
import { VasState } from "../../store/store-type";
import { createSelector } from "reselect";
import { pluralize } from "inflected";
import { IPageFilter } from "../../store/queries/page-filter.interface";
import { BaseObjectFilters } from "../../store/bootstrap";
import { IAclFilter } from "../../store/queries/acl-filter.interface";

export class BaseObjectQueryFactory<T extends BaseObject, F extends BaseObjectFilters> {

    protected _state: (state: VasState) => IState<T, F>;
    protected _entities: (state: VasState) => { [id: string]: T };
    protected _ids: (state: VasState) => Array<string>;
    protected _selected: itemSelector<T>;
    protected _filters: itemSelector<F>;
    protected _filtered: listSelector<T>;
    protected _items: listSelector<T>;

    constructor(protected entity: string, protected pageFilter: IPageFilter<T, F>, protected aclFilter: IAclFilter<T>) {

    }

    get state(): (state: VasState) => IState<T, F> {

        if (!this._state) {
            this._state = (state: VasState) => state[this.entity];
        }

        return this._state;
    }

    get entities(): (state: VasState) => { [id: string]: T } {
        if (!this._entities) {
            this._entities = createSelector(this.state, state => state.entities);
        }

        return this._entities;
    }

    get ids(): (state: VasState) => Array<string> {

        if (!this._ids) {
            this._ids = createSelector(this.state, state => state.ids);
        }
        return this._ids;
    }

    get items(): listSelector<T> {

        if (!this._items) {
            this._items = this.aclFilter.createSelector(this.ids, this.entities);
        }

        return this._items;
    }

    byId(id: string): (state) => (...args) => T {
        return state => state[this.entity].entities[id];
    }

    get selected(): itemSelector<T> {

        if (!this._selected) {
            this._selected = createSelector(this.items, this.state, (items, state) => {
                return items.find(item => item.id === state.selected);
            });
        }

        return this._selected;
    }

    get filters(): (state: VasState) => F {

        if (!this._filters) {
            this._filters = createSelector(this.state, state => state.filters);
        }

        return this._filters;
    }

    get filtered(): listSelector<T> {

        if (!this._filtered) {
            return this.pageFilter.createSelector(this.items, this.filters);
        }

        return this._filtered;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/base-object/base-object.query-factory.ts